"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8901],{

/***/ 98745:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ buttons_AddToCart; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/wagmi/dist/index.js + 25 modules
var dist = __webpack_require__(69077);
// EXTERNAL MODULE: ./node_modules/@reservoir0x/reservoir-kit-ui/dist/index.module.js + 197 modules
var index_module = __webpack_require__(9836);
// EXTERNAL MODULE: ./components/primitives/index.ts + 13 modules
var primitives = __webpack_require__(21666);
// EXTERNAL MODULE: ./node_modules/@rainbow-me/rainbowkit/dist/chunk-3B7JRKV5.js + 15 modules
var chunk_3B7JRKV5 = __webpack_require__(87671);
// EXTERNAL MODULE: ./hooks/index.ts + 7 modules
var hooks = __webpack_require__(82731);
// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js + 1 modules
var index_es = __webpack_require__(99603);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-solid-svg-icons/index.mjs
var free_solid_svg_icons = __webpack_require__(59417);
// EXTERNAL MODULE: ./context/ToastContextProvider.tsx + 4 modules
var ToastContextProvider = __webpack_require__(98045);
// EXTERNAL MODULE: ./components/primitives/Dialog.tsx
var Dialog = __webpack_require__(39114);
;// CONCATENATED MODULE: ./components/common/ConfirmationModal.tsx



const ConfirmationModal = (param)=>{
    let { title , message , confirmationText ="Continue" , open , onOpenChange , onConfirmed =()=>{}  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Dialog/* Dialog */.Vq, {
        open: open,
        onOpenChange: onOpenChange,
        overlayProps: {
            style: {
                opacity: 0.7
            }
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
            direction: "column",
            css: {
                p: 24,
                gap: "$2",
                background: "$gray2"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                    style: "subtitle1",
                    children: title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                    style: "body1",
                    color: "subtle",
                    children: message
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                    css: {
                        gap: "$2",
                        mt: "$4"
                    },
                    justify: "end",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Button */.zx, {
                            color: "gray3",
                            size: "medium",
                            onClick: ()=>{
                                onConfirmed(true);
                                onOpenChange === null || onOpenChange === void 0 ? void 0 : onOpenChange(false);
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                style: "subtitle2",
                                color: "error",
                                children: confirmationText
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Button */.zx, {
                            size: "medium",
                            onClick: ()=>{
                                onConfirmed(false);
                                onOpenChange === null || onOpenChange === void 0 ? void 0 : onOpenChange(false);
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                style: "subtitle2",
                                css: {
                                    color: "inherit"
                                },
                                children: "Cancel"
                            })
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/buttons/AddToCart.tsx











const AddToCart = (param)=>{
    let { token , orderId =undefined , buttonCss , buttonProps  } = param;
    var _token_market, _token_market_floorAsk, _token_market_floorAsk_price, _token_market1, _token_market_floorAsk1, _token_market_floorAsk_price1;
    const { addToast  } = (0,react.useContext)(ToastContextProvider/* ToastContext */.u);
    const { data: items , add , remove , clear  } = (0,index_module/* useCart */.jD)((cart)=>cart.items);
    const { data: cartChain  } = (0,index_module/* useCart */.jD)((cart)=>cart.chain);
    const { isConnected  } = (0,dist/* useAccount */.mA)();
    const { openConnectModal  } = (0,chunk_3B7JRKV5/* useConnectModal */.We)();
    const marketplaceChain = (0,hooks/* useMarketplaceChain */.gw)();
    const [confirmationOpen, setConfirmationOpen] = (0,react.useState)(false);
    const hasOrderId = !!orderId;
    if (hasOrderId) {
        const orderIsInCart = items.find((item)=>{
            var _item_order;
            return ((_item_order = item.order) === null || _item_order === void 0 ? void 0 : _item_order.id) === orderId;
        });
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Button */.zx, {
                    css: buttonCss,
                    color: "primary",
                    onClick: async ()=>{
                        if (!isConnected) {
                            openConnectModal === null || openConnectModal === void 0 ? void 0 : openConnectModal();
                        }
                        if (orderIsInCart) {
                            remove([
                                orderId
                            ]);
                        } else if (cartChain && (cartChain === null || cartChain === void 0 ? void 0 : cartChain.id) !== marketplaceChain.id) {
                            setConfirmationOpen(true);
                        } else {
                            add([
                                {
                                    orderId: orderId
                                }
                            ], marketplaceChain.id).then(()=>{
                                addToast === null || addToast === void 0 ? void 0 : addToast({
                                    title: "Added to cart"
                                });
                            });
                        }
                    },
                    ...buttonProps,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                        icon: orderIsInCart ? free_solid_svg_icons/* faMinus */.Kl4 : free_solid_svg_icons/* faShoppingCart */.sq$,
                        width: "16",
                        height: "16"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ConfirmationModal, {
                    title: "Could not add item to cart",
                    message: "Your cart has items from a different chain than the item you are trying to add. Adding this item will clear your existing cart and start a new one.",
                    open: confirmationOpen,
                    onOpenChange: setConfirmationOpen,
                    onConfirmed: (confirmed)=>{
                        if (confirmed) {
                            clear();
                            add([
                                {
                                    orderId: orderId
                                }
                            ], marketplaceChain.id);
                        }
                    }
                })
            ]
        });
    }
    if (!token || !("market" in token) && !("id" in token)) {
        return null;
    }
    if ("market" in token && ((token === null || token === void 0 ? void 0 : (_token_market = token.market) === null || _token_market === void 0 ? void 0 : (_token_market_floorAsk = _token_market.floorAsk) === null || _token_market_floorAsk === void 0 ? void 0 : (_token_market_floorAsk_price = _token_market_floorAsk.price) === null || _token_market_floorAsk_price === void 0 ? void 0 : _token_market_floorAsk_price.amount) === null || (token === null || token === void 0 ? void 0 : (_token_market1 = token.market) === null || _token_market1 === void 0 ? void 0 : (_token_market_floorAsk1 = _token_market1.floorAsk) === null || _token_market_floorAsk1 === void 0 ? void 0 : (_token_market_floorAsk_price1 = _token_market_floorAsk1.price) === null || _token_market_floorAsk_price1 === void 0 ? void 0 : _token_market_floorAsk_price1.amount) === undefined)) {
        return null;
    }
    let tokenKey = "";
    if ("id" in token) {
        tokenKey = token.id;
    } else {
        var _token_token, _token_token_collection, _token_token1;
        tokenKey = "".concat((_token_token = token.token) === null || _token_token === void 0 ? void 0 : (_token_token_collection = _token_token.collection) === null || _token_token_collection === void 0 ? void 0 : _token_token_collection.id, ":").concat((_token_token1 = token.token) === null || _token_token1 === void 0 ? void 0 : _token_token1.tokenId);
    }
    const isInCart = items.find((item)=>"".concat(item.collection.id, ":").concat(item.token.id) === tokenKey);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Button */.zx, {
                css: buttonCss,
                color: "primary",
                onClick: async ()=>{
                    if (!isConnected) {
                        openConnectModal === null || openConnectModal === void 0 ? void 0 : openConnectModal();
                    }
                    if (isInCart) {
                        remove([
                            tokenKey
                        ]);
                    } else if (cartChain && (cartChain === null || cartChain === void 0 ? void 0 : cartChain.id) !== marketplaceChain.id) {
                        setConfirmationOpen(true);
                    } else {
                        add([
                            token
                        ], marketplaceChain.id).then(()=>{
                            addToast === null || addToast === void 0 ? void 0 : addToast({
                                title: "Added to cart"
                            });
                        });
                    }
                },
                ...buttonProps,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                    icon: isInCart ? free_solid_svg_icons/* faMinus */.Kl4 : free_solid_svg_icons/* faShoppingCart */.sq$,
                    width: "16",
                    height: "16"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ConfirmationModal, {
                title: "Could not add item to cart",
                message: "Your cart has items from a different chain than the item you are trying to add. Adding this item will clear your existing cart and start a new one.",
                open: confirmationOpen,
                onOpenChange: setConfirmationOpen,
                onConfirmed: (confirmed)=>{
                    if (confirmed) {
                        clear();
                        add([
                            token
                        ], marketplaceChain.id);
                    }
                }
            })
        ]
    });
};
/* harmony default export */ var buttons_AddToCart = (AddToCart);


/***/ }),

/***/ 87441:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _rainbow_me_rainbowkit__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87671);
/* harmony import */ var _reservoir0x_reservoir_kit_ui__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9836);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82731);
/* harmony import */ var wagmi__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69077);
/* harmony import */ var components_primitives__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21666);
/* harmony import */ var context_ReferralContextProvider__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68048);








const Mint = (param)=>{
    let { collectionId , tokenId , buttonCss , buttonProps , buttonChildren , mutate , openState  } = param;
    const { data: signer  } = (0,wagmi__WEBPACK_IMPORTED_MODULE_5__/* .useWalletClient */ .py)();
    const { openConnectModal  } = (0,_rainbow_me_rainbowkit__WEBPACK_IMPORTED_MODULE_6__/* .useConnectModal */ .We)();
    const { chain: activeChain  } = (0,wagmi__WEBPACK_IMPORTED_MODULE_5__/* .useNetwork */ .LN)();
    const marketplaceChain = (0,hooks__WEBPACK_IMPORTED_MODULE_2__/* .useMarketplaceChain */ .gw)();
    const { switchNetworkAsync  } = (0,wagmi__WEBPACK_IMPORTED_MODULE_5__/* .useSwitchNetwork */ .g0)({
        chainId: marketplaceChain.id
    });
    const { feesOnTop  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(context_ReferralContextProvider__WEBPACK_IMPORTED_MODULE_4__/* .ReferralContext */ .g);
    (0,hooks__WEBPACK_IMPORTED_MODULE_2__/* .useRKModalPrepareDeeplink */ .q7)(marketplaceChain.id, openState ? true : false);
    const isInTheWrongNetwork = Boolean(signer && (activeChain === null || activeChain === void 0 ? void 0 : activeChain.id) !== marketplaceChain.id);
    const trigger = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .zx, {
        css: buttonCss,
        color: "primary",
        ...buttonProps,
        children: buttonChildren
    });
    const canSweep = signer && collectionId && !isInTheWrongNetwork;
    return !canSweep ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .zx, {
        css: buttonCss,
        "aria-haspopup": "dialog",
        color: "primary",
        onClick: async ()=>{
            if (isInTheWrongNetwork && switchNetworkAsync) {
                const chain = await switchNetworkAsync(marketplaceChain.id);
                if (chain.id !== marketplaceChain.id) {
                    return false;
                }
            }
            if (!signer) {
                openConnectModal === null || openConnectModal === void 0 ? void 0 : openConnectModal();
            }
        },
        ...buttonProps,
        children: buttonChildren
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_reservoir0x_reservoir_kit_ui__WEBPACK_IMPORTED_MODULE_7__/* .CollectModal */ .o5, {
        trigger: trigger,
        collectionId: collectionId,
        tokenId: tokenId,
        mode: "mint",
        openState: openState,
        feesOnTopUsd: feesOnTop,
        onClose: (data, currentStep)=>{
            if (mutate && currentStep == _reservoir0x_reservoir_kit_ui__WEBPACK_IMPORTED_MODULE_7__/* .CollectStep.Complete */ .$Z.Complete) mutate();
        }
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Mint);


/***/ }),

/***/ 7435:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _rainbow_me_rainbowkit__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87671);
/* harmony import */ var _reservoir0x_reservoir_kit_ui__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9836);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82731);
/* harmony import */ var wagmi__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69077);
/* harmony import */ var components_primitives__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21666);
/* harmony import */ var context_ReferralContextProvider__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68048);








const Sweep = (param)=>{
    let { collectionId , tokenId , buttonCss , buttonProps , buttonChildren , mutate , openState  } = param;
    const { data: signer  } = (0,wagmi__WEBPACK_IMPORTED_MODULE_5__/* .useWalletClient */ .py)();
    const { openConnectModal  } = (0,_rainbow_me_rainbowkit__WEBPACK_IMPORTED_MODULE_6__/* .useConnectModal */ .We)();
    const { chain: activeChain  } = (0,wagmi__WEBPACK_IMPORTED_MODULE_5__/* .useNetwork */ .LN)();
    const marketplaceChain = (0,hooks__WEBPACK_IMPORTED_MODULE_2__/* .useMarketplaceChain */ .gw)();
    const { switchNetworkAsync  } = (0,wagmi__WEBPACK_IMPORTED_MODULE_5__/* .useSwitchNetwork */ .g0)({
        chainId: marketplaceChain.id
    });
    const { feesOnTop  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(context_ReferralContextProvider__WEBPACK_IMPORTED_MODULE_4__/* .ReferralContext */ .g);
    (0,hooks__WEBPACK_IMPORTED_MODULE_2__/* .useRKModalPrepareDeeplink */ .q7)(marketplaceChain.id, openState ? true : false);
    const isInTheWrongNetwork = Boolean(signer && (activeChain === null || activeChain === void 0 ? void 0 : activeChain.id) !== marketplaceChain.id);
    const trigger = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .zx, {
        css: buttonCss,
        color: "primary",
        ...buttonProps,
        children: buttonChildren
    });
    const canSweep = signer && collectionId && !isInTheWrongNetwork;
    return !canSweep ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .zx, {
        css: buttonCss,
        "aria-haspopup": "dialog",
        color: "primary",
        onClick: async ()=>{
            if (isInTheWrongNetwork && switchNetworkAsync) {
                const chain = await switchNetworkAsync(marketplaceChain.id);
                if (chain.id !== marketplaceChain.id) {
                    return false;
                }
            }
            if (!signer) {
                openConnectModal === null || openConnectModal === void 0 ? void 0 : openConnectModal();
            }
        },
        ...buttonProps,
        children: buttonChildren
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_reservoir0x_reservoir_kit_ui__WEBPACK_IMPORTED_MODULE_7__/* .CollectModal */ .o5, {
        trigger: trigger,
        collectionId: collectionId,
        tokenId: tokenId,
        mode: "trade",
        openState: openState,
        //CONFIGURABLE: set any fees on top of orders, note that these will only
        // apply to native orders (using the reservoir order book) and not to external orders (opensea, blur etc)
        // Refer to our docs for more info: https://docs.reservoir.tools/reference/sweepmodal-1
        // feesOnTopBps={["0xabc:50"]}
        feesOnTopUsd: feesOnTop,
        onClose: (data, currentStep)=>{
            if (mutate && currentStep == _reservoir0x_reservoir_kit_ui__WEBPACK_IMPORTED_MODULE_7__/* .CollectStep.Complete */ .$Z.Complete) mutate();
        }
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Sweep);


/***/ }),

/***/ 76530:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _fortawesome_free_brands_svg_icons__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(93024);
/* harmony import */ var _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(59417);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99603);
/* harmony import */ var _stitches_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50530);
/* harmony import */ var components_primitives__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21666);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82731);
/* harmony import */ var next_themes__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(82010);
/* harmony import */ var components_primitives_Dropdown__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(12623);
/* harmony import */ var react_responsive__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(1852);
/* harmony import */ var react_responsive__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(react_responsive__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var utils_fetcher__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(84205);
/* harmony import */ var context_ToastContextProvider__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(98045);
/* harmony import */ var components_common_LoadingSpinner__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(74431);
/* harmony import */ var utils_till__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(94830);















const CollectionAction = (0,_stitches_config__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)(components_primitives__WEBPACK_IMPORTED_MODULE_3__/* .Flex */ .kC, {
    px: "$4",
    py: "$3",
    color: "$gray12",
    background: "$panelBg",
    cursor: "pointer",
    transition: "background 0.25s ease-in",
    height: 48,
    alignItems: "center",
    "&:hover": {
        background: "$gray4"
    }
});
const CollectionActionDropdownItem = (0,_stitches_config__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)(components_primitives__WEBPACK_IMPORTED_MODULE_3__/* .Flex */ .kC, {
    gap: "$3",
    cursor: "pointer",
    alignItems: "center",
    flexDirection: "row",
    px: "$4",
    py: 20,
    transition: "background 0.25s ease-in",
    "&:hover": {
        background: "$gray4"
    }
});
const CollectionActions = (param)=>{
    let { collection  } = param;
    var _marketplaceChain_blockExplorers, _marketplaceChain_blockExplorers1;
    const { addToast  } = (0,react__WEBPACK_IMPORTED_MODULE_4__.useContext)(context_ToastContextProvider__WEBPACK_IMPORTED_MODULE_9__/* .ToastContext */ .u);
    const isMounted = (0,hooks__WEBPACK_IMPORTED_MODULE_5__/* .useMounted */ .s4)();
    const isMobile = (0,react_responsive__WEBPACK_IMPORTED_MODULE_12__.useMediaQuery)({
        maxWidth: 600
    }) && isMounted;
    const [isRefreshing, setIsRefreshing] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false);
    const marketplaceChain = (0,hooks__WEBPACK_IMPORTED_MODULE_5__/* .useMarketplaceChain */ .gw)();
    const { theme  } = (0,next_themes__WEBPACK_IMPORTED_MODULE_6__/* .useTheme */ .F)();
    const etherscanImage = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
        src: isMounted && theme === "dark" ? "/icons/etherscan-logo-light-circle.svg" : "/icons/etherscan-logo-circle.svg",
        alt: ((_marketplaceChain_blockExplorers = marketplaceChain.blockExplorers) === null || _marketplaceChain_blockExplorers === void 0 ? void 0 : _marketplaceChain_blockExplorers.default.name) || "Etherscan",
        style: {
            height: 16,
            width: 16
        }
    });
    const blockExplorerUrl = "".concat((marketplaceChain === null || marketplaceChain === void 0 ? void 0 : (_marketplaceChain_blockExplorers1 = marketplaceChain.blockExplorers) === null || _marketplaceChain_blockExplorers1 === void 0 ? void 0 : _marketplaceChain_blockExplorers1.default.url) || "https://etherscan.io", "/address/").concat(collection === null || collection === void 0 ? void 0 : collection.id);
    const twitterLink = (collection === null || collection === void 0 ? void 0 : collection.twitterUsername) ? "https://twitter.com/".concat(collection === null || collection === void 0 ? void 0 : collection.twitterUsername) : null;
    const containerCss = {
        borderRadius: 8,
        overflow: "hidden",
        gap: 1,
        flexShrink: 0,
        mb: "auto"
    };
    const dropdownContentProps = {
        sideOffset: 4,
        style: {
            padding: 0,
            overflow: "hidden"
        }
    };
    const collectionActionOverflowTrigger = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CollectionAction, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__/* .FontAwesomeIcon */ .G, {
            icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_13__/* .faEllipsis */ .S6C,
            width: 16,
            height: 16
        })
    });
    const refreshMetadataItem = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(CollectionActionDropdownItem, {
        css: {
            cursor: isRefreshing ? "not-allowed" : "pointer"
        },
        onClick: (e)=>{
            if (isRefreshing) {
                e.preventDefault();
                return;
            }
            setIsRefreshing(true);
            (0,utils_fetcher__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)("".concat(window.location.origin, "/").concat(marketplaceChain.proxyApi, "/collections/refresh/v2"), undefined, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    collection: collection.id
                })
            }).then((param)=>{
                let { data , response  } = param;
                if (response.status === 200) {
                    addToast === null || addToast === void 0 ? void 0 : addToast({
                        title: "Refresh collection",
                        description: "Request to refresh collection was accepted."
                    });
                } else {
                    throw data;
                }
                setIsRefreshing(false);
            }).catch((e)=>{
                var _DATE_REGEX_exec;
                const ratelimit = (_DATE_REGEX_exec = utils_till__WEBPACK_IMPORTED_MODULE_11__/* .DATE_REGEX.exec */ .n.exec(e === null || e === void 0 ? void 0 : e.message)) === null || _DATE_REGEX_exec === void 0 ? void 0 : _DATE_REGEX_exec[0];
                addToast === null || addToast === void 0 ? void 0 : addToast({
                    title: "Refresh collection failed",
                    description: ratelimit ? "This collection was recently refreshed. The next available refresh is ".concat((0,utils_till__WEBPACK_IMPORTED_MODULE_11__/* .timeTill */ .x)(ratelimit), ".") : "This collection was recently refreshed. Please try again later."
                });
                setIsRefreshing(false);
                throw e;
            });
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
                css: {
                    animation: isRefreshing ? "".concat(components_common_LoadingSpinner__WEBPACK_IMPORTED_MODULE_10__/* .spin */ .O, " 1s cubic-bezier(0.76, 0.35, 0.2, 0.7) infinite") : "none"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__/* .FontAwesomeIcon */ .G, {
                    icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_13__/* .faRefresh */ .QDM,
                    width: 16,
                    height: 16
                })
            }),
            "Refresh Metadata"
        ]
    });
    if (isMobile) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_3__/* .Flex */ .kC, {
            css: containerCss,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives_Dropdown__WEBPACK_IMPORTED_MODULE_7__/* .Dropdown */ .Lt, {
                trigger: collectionActionOverflowTrigger,
                contentProps: dropdownContentProps,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_primitives__WEBPACK_IMPORTED_MODULE_3__/* .Flex */ .kC, {
                    direction: "column",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: blockExplorerUrl,
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(CollectionActionDropdownItem, {
                                children: [
                                    etherscanImage,
                                    "Etherscan"
                                ]
                            })
                        }),
                        (collection === null || collection === void 0 ? void 0 : collection.externalUrl) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: collection.externalUrl,
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(CollectionActionDropdownItem, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__/* .FontAwesomeIcon */ .G, {
                                        icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_13__/* .faGlobe */ .g4A,
                                        width: 16,
                                        height: 16
                                    }),
                                    "Website"
                                ]
                            })
                        }),
                        (collection === null || collection === void 0 ? void 0 : collection.discordUrl) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: collection.discordUrl,
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(CollectionActionDropdownItem, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__/* .FontAwesomeIcon */ .G, {
                                        icon: _fortawesome_free_brands_svg_icons__WEBPACK_IMPORTED_MODULE_14__/* .faDiscord */ .omb,
                                        width: 16,
                                        height: 16
                                    }),
                                    " ",
                                    "Discord"
                                ]
                            })
                        }),
                        twitterLink && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: twitterLink,
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(CollectionActionDropdownItem, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__/* .FontAwesomeIcon */ .G, {
                                        icon: _fortawesome_free_brands_svg_icons__WEBPACK_IMPORTED_MODULE_14__/* .faTwitter */ .mdU,
                                        width: 16,
                                        height: 16
                                    }),
                                    " ",
                                    "Twitter"
                                ]
                            })
                        }),
                        refreshMetadataItem
                    ]
                })
            })
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_primitives__WEBPACK_IMPORTED_MODULE_3__/* .Flex */ .kC, {
        css: containerCss,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                href: blockExplorerUrl,
                target: "_blank",
                rel: "noopener noreferrer",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CollectionAction, {
                    children: etherscanImage
                })
            }),
            twitterLink && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                href: twitterLink,
                target: "_blank",
                rel: "noopener noreferrer",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CollectionAction, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__/* .FontAwesomeIcon */ .G, {
                        icon: _fortawesome_free_brands_svg_icons__WEBPACK_IMPORTED_MODULE_14__/* .faTwitter */ .mdU,
                        width: 16,
                        height: 16
                    })
                })
            }),
            (collection === null || collection === void 0 ? void 0 : collection.discordUrl) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                href: collection.discordUrl,
                target: "_blank",
                rel: "noopener noreferrer",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CollectionAction, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__/* .FontAwesomeIcon */ .G, {
                        icon: _fortawesome_free_brands_svg_icons__WEBPACK_IMPORTED_MODULE_14__/* .faDiscord */ .omb,
                        width: 16,
                        height: 16
                    })
                })
            }),
            (collection === null || collection === void 0 ? void 0 : collection.externalUrl) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                href: collection.externalUrl,
                target: "_blank",
                rel: "noopener noreferrer",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CollectionAction, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__/* .FontAwesomeIcon */ .G, {
                        icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_13__/* .faGlobe */ .g4A,
                        width: 16,
                        height: 16
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives_Dropdown__WEBPACK_IMPORTED_MODULE_7__/* .Dropdown */ .Lt, {
                trigger: collectionActionOverflowTrigger,
                contentProps: dropdownContentProps,
                children: refreshMetadataItem
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CollectionActions);


/***/ }),

/***/ 80596:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ CollectionActivityTable; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var components_common_ActivityTable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31322);
/* harmony import */ var _reservoir0x_reservoir_kit_ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9836);




const CollectionActivityTable = (param)=>{
    let { id , activityTypes  } = param;
    const data = (0,_reservoir0x_reservoir_kit_ui__WEBPACK_IMPORTED_MODULE_3__/* .useCollectionActivity */ .UH)({
        collection: id,
        types: activityTypes,
        limit: 20
    }, {
        revalidateOnMount: true,
        fallbackData: []
    });
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        data.mutate();
        return ()=>{
            data.setSize(1);
        };
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common_ActivityTable__WEBPACK_IMPORTED_MODULE_2__/* .ActivityTable */ .T, {
        data: data
    });
};


/***/ }),

/***/ 58955:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ SortTokens; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var components_primitives__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21666);
/* harmony import */ var components_primitives_Dropdown__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12623);
/* harmony import */ var _radix_ui_react_dropdown_menu__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(84113);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(59417);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99603);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(82731);
/* harmony import */ var react_responsive__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1852);
/* harmony import */ var react_responsive__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(react_responsive__WEBPACK_IMPORTED_MODULE_7__);










const options = {
    "Price low to high": {
        sortBy: "floorAskPrice",
        sortDirection: "asc"
    },
    "Price high to low": {
        sortBy: "floorAskPrice",
        sortDirection: "desc"
    },
    "Rare to common": {
        sortBy: "rarity",
        sortDirection: "asc"
    },
    "Common to rare": {
        sortBy: "rarity",
        sortDirection: "desc"
    }
};
const SortTokens = (param)=>{
    let { css  } = param;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    const [sortSelection, setSortSelection] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)("Price low to high");
    const isMounted = (0,hooks__WEBPACK_IMPORTED_MODULE_6__/* .useMounted */ .s4)();
    const isSmallDevice = (0,react_responsive__WEBPACK_IMPORTED_MODULE_7__.useMediaQuery)({
        maxWidth: 905
    }) && isMounted;
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(()=>{
        var _router_query_sortBy, _router_query_sortDirection;
        const sortBy = (_router_query_sortBy = router === null || router === void 0 ? void 0 : router.query["sortBy"]) === null || _router_query_sortBy === void 0 ? void 0 : _router_query_sortBy.toString();
        const sortDirection = (_router_query_sortDirection = router === null || router === void 0 ? void 0 : router.query["sortDirection"]) === null || _router_query_sortDirection === void 0 ? void 0 : _router_query_sortDirection.toString();
        if (sortBy === "rarity" && sortDirection === "desc") {
            setSortSelection("Common to rare");
            return;
        }
        if (sortBy === "rarity" && sortDirection === "asc") {
            setSortSelection("Rare to common");
            return;
        }
        if (sortBy === "floorAskPrice" && sortDirection === "desc") {
            setSortSelection("Price high to low");
            return;
        }
        setSortSelection("Price low to high");
    }, [
        router.query
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_radix_ui_react_dropdown_menu__WEBPACK_IMPORTED_MODULE_8__/* .Root */ .fC, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_dropdown_menu__WEBPACK_IMPORTED_MODULE_8__/* .Trigger */ .xz, {
                asChild: true,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zx, {
                    color: "gray3",
                    css: {
                        ...css
                    },
                    children: isSmallDevice ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_5__/* .FontAwesomeIcon */ .G, {
                        icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_9__/* .faSort */ .CmM,
                        width: 16,
                        height: 16
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                children: sortSelection
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
                                css: {
                                    transition: "transform",
                                    "[data-state=open] &": {
                                        transform: "rotate(180deg)"
                                    }
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_5__/* .FontAwesomeIcon */ .G, {
                                    icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_9__/* .faChevronDown */ .ptq,
                                    width: 16
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives_Dropdown__WEBPACK_IMPORTED_MODULE_2__/* .DropdownMenuContent */ .AW, {
                css: {
                    width: "220px",
                    mt: "$2",
                    zIndex: 1000
                },
                children: Object.keys(options).map((key)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives_Dropdown__WEBPACK_IMPORTED_MODULE_2__/* .DropdownMenuItem */ .Xi, {
                        css: {
                            py: "$3"
                        },
                        onClick: ()=>{
                            router.push({
                                query: {
                                    ...router.query,
                                    ["sortBy"]: options[key].sortBy,
                                    ["sortDirection"]: options[key].sortDirection
                                }
                            }, undefined, {
                                shallow: true
                            });
                        },
                        "aria-label": "Sort by ".concat(key),
                        children: key
                    }, key))
            })
        ]
    });
};


/***/ }),

/***/ 55614:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var components_primitives__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21666);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82731);
/* harmony import */ var react_responsive__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1852);
/* harmony import */ var react_responsive__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(react_responsive__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var utils_numbers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23701);





const StatBox = (param)=>/*#__PURE__*/ {
    let { label , children  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
        css: {
            p: "$4",
            minWidth: 120,
            background: "$panelBg"
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
                style: "subtitle3",
                css: {
                    color: "$gray12"
                },
                as: "p",
                children: label
            }),
            children
        ]
    });
};
const StatHeader = (param)=>{
    let { collection  } = param;
    var _collection_floorAsk, _collection_floorAsk_price, _collection_floorAsk_price_amount, _collection_floorAsk1, _collection_floorAsk_price1, _collection_floorAsk_price_currency, _collection_floorAsk2, _collection_floorAsk_price2, _collection_floorAsk_price_currency1, _collection_topBid, _collection_topBid_price, _collection_topBid_price_amount, _collection_topBid1, _collection_topBid_price1, _collection_topBid_price_currency, _collection_topBid2, _collection_topBid_price2, _collection_topBid_price_currency1, _collection_volume;
    const isMounted = (0,hooks__WEBPACK_IMPORTED_MODULE_2__/* .useMounted */ .s4)();
    const isSmallDevice = (0,react_responsive__WEBPACK_IMPORTED_MODULE_4__.useMediaQuery)({
        maxWidth: 600
    }) && isMounted;
    const listedPercentage = ((collection === null || collection === void 0 ? void 0 : collection.onSaleCount) ? +collection.onSaleCount : 0) / ((collection === null || collection === void 0 ? void 0 : collection.tokenCount) ? +collection.tokenCount : 0) * 100;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Grid */ .rj, {
        css: {
            borderRadius: 8,
            overflow: "hidden",
            gap: 1,
            gridTemplateColumns: "1fr 1fr",
            "@sm": {
                gridTemplateColumns: "1fr 1fr 1fr 1fr 1fr",
                marginRight: "auto"
            }
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StatBox, {
                label: "Floor",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .FormatCryptoCurrency */ .gv, {
                    amount: collection === null || collection === void 0 ? void 0 : (_collection_floorAsk = collection.floorAsk) === null || _collection_floorAsk === void 0 ? void 0 : (_collection_floorAsk_price = _collection_floorAsk.price) === null || _collection_floorAsk_price === void 0 ? void 0 : (_collection_floorAsk_price_amount = _collection_floorAsk_price.amount) === null || _collection_floorAsk_price_amount === void 0 ? void 0 : _collection_floorAsk_price_amount.decimal,
                    address: collection === null || collection === void 0 ? void 0 : (_collection_floorAsk1 = collection.floorAsk) === null || _collection_floorAsk1 === void 0 ? void 0 : (_collection_floorAsk_price1 = _collection_floorAsk1.price) === null || _collection_floorAsk_price1 === void 0 ? void 0 : (_collection_floorAsk_price_currency = _collection_floorAsk_price1.currency) === null || _collection_floorAsk_price_currency === void 0 ? void 0 : _collection_floorAsk_price_currency.contract,
                    decimals: collection === null || collection === void 0 ? void 0 : (_collection_floorAsk2 = collection.floorAsk) === null || _collection_floorAsk2 === void 0 ? void 0 : (_collection_floorAsk_price2 = _collection_floorAsk2.price) === null || _collection_floorAsk_price2 === void 0 ? void 0 : (_collection_floorAsk_price_currency1 = _collection_floorAsk_price2.currency) === null || _collection_floorAsk_price_currency1 === void 0 ? void 0 : _collection_floorAsk_price_currency1.decimals,
                    logoHeight: 18,
                    textStyle: "h6",
                    maximumFractionDigits: 4
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StatBox, {
                label: "Top Offer",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .FormatCryptoCurrency */ .gv, {
                    amount: collection === null || collection === void 0 ? void 0 : (_collection_topBid = collection.topBid) === null || _collection_topBid === void 0 ? void 0 : (_collection_topBid_price = _collection_topBid.price) === null || _collection_topBid_price === void 0 ? void 0 : (_collection_topBid_price_amount = _collection_topBid_price.amount) === null || _collection_topBid_price_amount === void 0 ? void 0 : _collection_topBid_price_amount.decimal,
                    address: collection === null || collection === void 0 ? void 0 : (_collection_topBid1 = collection.topBid) === null || _collection_topBid1 === void 0 ? void 0 : (_collection_topBid_price1 = _collection_topBid1.price) === null || _collection_topBid_price1 === void 0 ? void 0 : (_collection_topBid_price_currency = _collection_topBid_price1.currency) === null || _collection_topBid_price_currency === void 0 ? void 0 : _collection_topBid_price_currency.contract,
                    decimals: collection === null || collection === void 0 ? void 0 : (_collection_topBid2 = collection.topBid) === null || _collection_topBid2 === void 0 ? void 0 : (_collection_topBid_price2 = _collection_topBid2.price) === null || _collection_topBid_price2 === void 0 ? void 0 : (_collection_topBid_price_currency1 = _collection_topBid_price2.currency) === null || _collection_topBid_price_currency1 === void 0 ? void 0 : _collection_topBid_price_currency1.decimals,
                    logoHeight: 18,
                    textStyle: "h6",
                    maximumFractionDigits: 4
                })
            }),
            !isSmallDevice && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StatBox, {
                label: "Listed",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
                    style: "h6",
                    children: [
                        (0,utils_numbers__WEBPACK_IMPORTED_MODULE_3__/* .formatNumber */ .uf)(listedPercentage),
                        "%"
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StatBox, {
                label: "Total Volume",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .FormatCryptoCurrency */ .gv, {
                    amount: (_collection_volume = collection.volume) === null || _collection_volume === void 0 ? void 0 : _collection_volume.allTime,
                    logoHeight: 18,
                    textStyle: "h6",
                    maximumFractionDigits: 4
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StatBox, {
                label: "Count",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
                    style: "h6",
                    children: (0,utils_numbers__WEBPACK_IMPORTED_MODULE_3__/* .formatNumber */ .uf)(collection === null || collection === void 0 ? void 0 : collection.tokenCount)
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (StatHeader);


/***/ }),

/***/ 51099:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(59417);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99603);
/* harmony import */ var _reservoir0x_reservoir_kit_ui__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(9836);
/* harmony import */ var components_buttons_AddToCart__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98745);
/* harmony import */ var components_buttons_BuyNow__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66918);
/* harmony import */ var components_primitives__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(21666);
/* harmony import */ var context_ToastContextProvider__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(98045);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(82731);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(67294);
/* harmony import */ var utils_numbers__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(23701);












/* harmony default export */ __webpack_exports__["Z"] = ((param)=>{
    let { token , address , rarityEnabled =true , addToCartEnabled =true , mutate , onMediaPlayed , tokenCount  } = param;
    var _token_token, _token_token_owner, _token_token1, _token_token2, _token_token3, _token_token4, _token_token5, _token_token6, _token_token7, _token_token8, _token_token9, _token_token10, _token_token11, _token_token12, _token_market, _token_market_floorAsk, _token_market1, _token_market_floorAsk1, _token_market_floorAsk_price, _token_market_floorAsk_price_amount, _token_market2, _token_market_floorAsk2, _token_market_floorAsk_price1, _token_market_floorAsk_price_currency, _token_market3, _token_market_floorAsk3, _token_market4, _token_market_floorAsk4, _token_market5, _token_market_floorAsk5, _token_market_floorAsk_source, _token_market6, _token_market_floorAsk6, _token_market_floorAsk_source1, _token_token13, _token_token_lastSale, _token_token_lastSale_price, _token_token_lastSale_price_amount, _token_token_lastSale_price_amount1, _token_token_lastSale_price_currency, _token_token_lastSale_price_currency1, _token_market7, _token_market_floorAsk7, _token_market_floorAsk_price2, _token_token14, _token_token15, _token_token_collection;
    const { addToast  } = (0,react__WEBPACK_IMPORTED_MODULE_8__.useContext)(context_ToastContextProvider__WEBPACK_IMPORTED_MODULE_5__/* .ToastContext */ .u);
    const mediaType = (0,_reservoir0x_reservoir_kit_ui__WEBPACK_IMPORTED_MODULE_10__/* .extractMediaType */ .uh)(token === null || token === void 0 ? void 0 : token.token);
    const showPreview = mediaType === "other" || mediaType === "html" || mediaType === null;
    const { routePrefix , proxyApi  } = (0,hooks__WEBPACK_IMPORTED_MODULE_6__/* .useMarketplaceChain */ .gw)();
    const tokenIsInCart = token && (token === null || token === void 0 ? void 0 : token.isInCart);
    const isOwner = (token === null || token === void 0 ? void 0 : (_token_token = token.token) === null || _token_token === void 0 ? void 0 : (_token_token_owner = _token_token.owner) === null || _token_token_owner === void 0 ? void 0 : _token_token_owner.toLowerCase()) !== (address === null || address === void 0 ? void 0 : address.toLowerCase());
    const is1155 = (token === null || token === void 0 ? void 0 : (_token_token1 = token.token) === null || _token_token1 === void 0 ? void 0 : _token_token1.kind) === "erc1155";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_primitives__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .xu, {
        css: {
            borderRadius: 8,
            overflow: "hidden",
            background: "$neutralBgSubtle",
            $$shadowColor: "$colors$panelShadow",
            boxShadow: "0 8px 12px 0px $$shadowColor",
            position: "relative",
            "&:hover > a > div > img": {
                transform: "scale(1.1)"
            },
            "@sm": {
                "&:hover .token-button-container": {
                    bottom: 0
                }
            }
        },
        children: [
            tokenCount && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_4__/* .Flex */ .kC, {
                justify: "center",
                align: "center",
                css: {
                    borderRadius: 8,
                    px: "$2",
                    py: "$1",
                    mr: "$2",
                    position: "absolute",
                    left: "$2",
                    top: "$2",
                    zIndex: 1,
                    maxWidth: "50%",
                    backgroundColor: "rgba(	38, 41, 43, 0.3)"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_primitives__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .xv, {
                    css: {
                        color: "$whiteA12"
                    },
                    ellipsify: true,
                    children: [
                        "x",
                        tokenCount
                    ]
                })
            }),
            is1155 && (token === null || token === void 0 ? void 0 : (_token_token2 = token.token) === null || _token_token2 === void 0 ? void 0 : _token_token2.supply) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_4__/* .Flex */ .kC, {
                justify: "center",
                align: "center",
                css: {
                    borderRadius: 8,
                    px: "$2",
                    py: "$1",
                    mr: "$2",
                    position: "absolute",
                    left: "$2",
                    top: "$2",
                    zIndex: 1,
                    maxWidth: "50%",
                    backgroundColor: "rgba(	38, 41, 43, 0.3)",
                    backdropFilter: "blur(2px)"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_primitives__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .xv, {
                    css: {
                        color: "$whiteA12"
                    },
                    ellipsify: true,
                    children: [
                        "x",
                        (0,utils_numbers__WEBPACK_IMPORTED_MODULE_9__/* .formatNumber */ .uf)(token === null || token === void 0 ? void 0 : (_token_token3 = token.token) === null || _token_token3 === void 0 ? void 0 : _token_token3.supply, 0, true)
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_4__/* .Flex */ .kC, {
                justify: "center",
                align: "center",
                css: {
                    borderRadius: "99999px",
                    width: 48,
                    height: 48,
                    backgroundColor: "$primary9",
                    position: "absolute",
                    right: "$2",
                    zIndex: 1,
                    transition: "visibility 0s linear ".concat(tokenIsInCart ? "" : "250ms", ", opacity 250ms ease-in-out, top 250ms ease-in-out"),
                    opacity: tokenIsInCart ? 1 : 0,
                    top: tokenIsInCart ? "$2" : 50,
                    visibility: tokenIsInCart ? "visible" : "hidden",
                    color: "white"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__/* .FontAwesomeIcon */ .G, {
                    icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_11__/* .faCheck */ .LEp,
                    width: 20,
                    height: 20
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_7___default()), {
                passHref: true,
                href: "/".concat(routePrefix, "/asset/").concat(token === null || token === void 0 ? void 0 : (_token_token4 = token.token) === null || _token_token4 === void 0 ? void 0 : _token_token4.contract, ":").concat(token === null || token === void 0 ? void 0 : (_token_token5 = token.token) === null || _token_token5 === void 0 ? void 0 : _token_token5.tokenId),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .xu, {
                    css: {
                        background: "$gray3",
                        overflow: "hidden"
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_reservoir0x_reservoir_kit_ui__WEBPACK_IMPORTED_MODULE_10__/* .TokenMedia */ .Y1, {
                        token: token === null || token === void 0 ? void 0 : token.token,
                        style: {
                            width: "100%",
                            transition: "transform .3s ease-in-out",
                            maxHeight: 720,
                            height: "100%",
                            borderRadius: 0,
                            aspectRatio: "1/1"
                        },
                        staticOnly: showPreview,
                        audioOptions: {
                            onPlay: (e)=>{
                                onMediaPlayed === null || onMediaPlayed === void 0 ? void 0 : onMediaPlayed(e);
                            }
                        },
                        videoOptions: {
                            onPlay: (e)=>{
                                onMediaPlayed === null || onMediaPlayed === void 0 ? void 0 : onMediaPlayed(e);
                            }
                        },
                        onRefreshToken: ()=>{
                            mutate === null || mutate === void 0 ? void 0 : mutate();
                            addToast === null || addToast === void 0 ? void 0 : addToast({
                                title: "Refresh token",
                                description: "Request to refresh this token was accepted."
                            });
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_7___default()), {
                href: "/".concat(routePrefix, "/asset/").concat(token === null || token === void 0 ? void 0 : (_token_token6 = token.token) === null || _token_token6 === void 0 ? void 0 : _token_token6.contract, ":").concat(token === null || token === void 0 ? void 0 : (_token_token7 = token.token) === null || _token_token7 === void 0 ? void 0 : _token_token7.tokenId),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_primitives__WEBPACK_IMPORTED_MODULE_4__/* .Flex */ .kC, {
                    css: {
                        p: "$4",
                        minHeight: 132,
                        cursor: "pointer"
                    },
                    direction: "column",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_primitives__WEBPACK_IMPORTED_MODULE_4__/* .Flex */ .kC, {
                            css: {
                                mb: "$4"
                            },
                            align: "center",
                            justify: "between",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_primitives__WEBPACK_IMPORTED_MODULE_4__/* .Flex */ .kC, {
                                    align: "center",
                                    css: {
                                        gap: "$1",
                                        minWidth: 0
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_primitives__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .xv, {
                                            style: "subtitle1",
                                            as: "p",
                                            ellipsify: true,
                                            css: {
                                                pr: "$1",
                                                flex: 1
                                            },
                                            children: [
                                                (token === null || token === void 0 ? void 0 : (_token_token8 = token.token) === null || _token_token8 === void 0 ? void 0 : _token_token8.name) || "#" + (token === null || token === void 0 ? void 0 : (_token_token9 = token.token) === null || _token_token9 === void 0 ? void 0 : _token_token9.tokenId),
                                                " "
                                            ]
                                        }),
                                        (token === null || token === void 0 ? void 0 : (_token_token10 = token.token) === null || _token_token10 === void 0 ? void 0 : _token_token10.isFlagged) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_4__/* .Tooltip */ .u, {
                                            content: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .xv, {
                                                style: "body3",
                                                as: "p",
                                                children: "Not tradeable on OpenSea"
                                            }),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .xv, {
                                                css: {
                                                    color: "$red10"
                                                },
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__/* .FontAwesomeIcon */ .G, {
                                                    icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_11__/* .faCircleExclamation */ .xHz,
                                                    width: 16,
                                                    height: 16
                                                })
                                            })
                                        })
                                    ]
                                }),
                                rarityEnabled && !is1155 && (token === null || token === void 0 ? void 0 : (_token_token11 = token.token) === null || _token_token11 === void 0 ? void 0 : _token_token11.rarityRank) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .xu, {
                                    css: {
                                        px: "$1",
                                        py: 2,
                                        background: "$gray5",
                                        borderRadius: 8,
                                        minWidth: "max-content"
                                    },
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_primitives__WEBPACK_IMPORTED_MODULE_4__/* .Flex */ .kC, {
                                        align: "center",
                                        css: {
                                            gap: 5
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                style: {
                                                    width: 13,
                                                    height: 13
                                                },
                                                src: "/icons/rarity-icon.svg"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .xv, {
                                                style: "subtitle3",
                                                as: "p",
                                                children: (0,utils_numbers__WEBPACK_IMPORTED_MODULE_9__/* .formatNumber */ .uf)(token === null || token === void 0 ? void 0 : (_token_token12 = token.token) === null || _token_token12 === void 0 ? void 0 : _token_token12.rarityRank)
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_primitives__WEBPACK_IMPORTED_MODULE_4__/* .Flex */ .kC, {
                            align: "center",
                            justify: "between",
                            css: {
                                gap: "$2"
                            },
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_primitives__WEBPACK_IMPORTED_MODULE_4__/* .Flex */ .kC, {
                                    align: "center",
                                    css: {
                                        gap: "$2"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .xu, {
                                            css: {
                                                flex: 1,
                                                minWidth: 0,
                                                width: "100%",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis"
                                            },
                                            children: (token === null || token === void 0 ? void 0 : (_token_market = token.market) === null || _token_market === void 0 ? void 0 : (_token_market_floorAsk = _token_market.floorAsk) === null || _token_market_floorAsk === void 0 ? void 0 : _token_market_floorAsk.price) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_4__/* .FormatCryptoCurrency */ .gv, {
                                                logoHeight: 18,
                                                amount: token === null || token === void 0 ? void 0 : (_token_market1 = token.market) === null || _token_market1 === void 0 ? void 0 : (_token_market_floorAsk1 = _token_market1.floorAsk) === null || _token_market_floorAsk1 === void 0 ? void 0 : (_token_market_floorAsk_price = _token_market_floorAsk1.price) === null || _token_market_floorAsk_price === void 0 ? void 0 : (_token_market_floorAsk_price_amount = _token_market_floorAsk_price.amount) === null || _token_market_floorAsk_price_amount === void 0 ? void 0 : _token_market_floorAsk_price_amount.decimal,
                                                address: token === null || token === void 0 ? void 0 : (_token_market2 = token.market) === null || _token_market2 === void 0 ? void 0 : (_token_market_floorAsk2 = _token_market2.floorAsk) === null || _token_market_floorAsk2 === void 0 ? void 0 : (_token_market_floorAsk_price1 = _token_market_floorAsk2.price) === null || _token_market_floorAsk_price1 === void 0 ? void 0 : (_token_market_floorAsk_price_currency = _token_market_floorAsk_price1.currency) === null || _token_market_floorAsk_price_currency === void 0 ? void 0 : _token_market_floorAsk_price_currency.contract,
                                                textStyle: "h6",
                                                css: {
                                                    textOverflow: "ellipsis",
                                                    minWidth: 0,
                                                    with: "100%",
                                                    overflow: "hidden"
                                                },
                                                maximumFractionDigits: 4
                                            })
                                        }),
                                        is1155 && (token === null || token === void 0 ? void 0 : (_token_market3 = token.market) === null || _token_market3 === void 0 ? void 0 : (_token_market_floorAsk3 = _token_market3.floorAsk) === null || _token_market_floorAsk3 === void 0 ? void 0 : _token_market_floorAsk3.quantityRemaining) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_primitives__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .xv, {
                                            style: "subtitle2",
                                            ellipsify: true,
                                            children: [
                                                "x",
                                                (0,utils_numbers__WEBPACK_IMPORTED_MODULE_9__/* .formatNumber */ .uf)(token === null || token === void 0 ? void 0 : (_token_market4 = token.market) === null || _token_market4 === void 0 ? void 0 : (_token_market_floorAsk4 = _token_market4.floorAsk) === null || _token_market_floorAsk4 === void 0 ? void 0 : _token_market_floorAsk4.quantityRemaining, 0, true)
                                            ]
                                        }) : null
                                    ]
                                }),
                                (token === null || token === void 0 ? void 0 : (_token_market5 = token.market) === null || _token_market5 === void 0 ? void 0 : (_token_market_floorAsk5 = _token_market5.floorAsk) === null || _token_market_floorAsk5 === void 0 ? void 0 : (_token_market_floorAsk_source = _token_market_floorAsk5.source) === null || _token_market_floorAsk_source === void 0 ? void 0 : _token_market_floorAsk_source.name) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    style: {
                                        width: 20,
                                        height: 20,
                                        borderRadius: "50%"
                                    },
                                    onClick: (e)=>{
                                        var _token_market, _token_market_floorAsk, _token_market_floorAsk_source, _token_token, _token_token1;
                                        e.preventDefault();
                                        e.stopPropagation();
                                        const url = "".concat(proxyApi, "/redirect/sources/").concat(token === null || token === void 0 ? void 0 : (_token_market = token.market) === null || _token_market === void 0 ? void 0 : (_token_market_floorAsk = _token_market.floorAsk) === null || _token_market_floorAsk === void 0 ? void 0 : (_token_market_floorAsk_source = _token_market_floorAsk.source) === null || _token_market_floorAsk_source === void 0 ? void 0 : _token_market_floorAsk_source.domain, "/tokens/").concat(token === null || token === void 0 ? void 0 : (_token_token = token.token) === null || _token_token === void 0 ? void 0 : _token_token.contract, ":").concat(token === null || token === void 0 ? void 0 : (_token_token1 = token.token) === null || _token_token1 === void 0 ? void 0 : _token_token1.tokenId, "/link/v2");
                                        window.open(url, "_blank");
                                    },
                                    src: "".concat(proxyApi, "/redirect/sources/").concat(token === null || token === void 0 ? void 0 : (_token_market6 = token.market) === null || _token_market6 === void 0 ? void 0 : (_token_market_floorAsk6 = _token_market6.floorAsk) === null || _token_market_floorAsk6 === void 0 ? void 0 : (_token_market_floorAsk_source1 = _token_market_floorAsk6.source) === null || _token_market_floorAsk_source1 === void 0 ? void 0 : _token_market_floorAsk_source1.domain, "/logo/v2")
                                }) : null
                            ]
                        }),
                        (token === null || token === void 0 ? void 0 : (_token_token13 = token.token) === null || _token_token13 === void 0 ? void 0 : (_token_token_lastSale = _token_token13.lastSale) === null || _token_token_lastSale === void 0 ? void 0 : (_token_token_lastSale_price = _token_token_lastSale.price) === null || _token_token_lastSale_price === void 0 ? void 0 : (_token_token_lastSale_price_amount = _token_token_lastSale_price.amount) === null || _token_token_lastSale_price_amount === void 0 ? void 0 : _token_token_lastSale_price_amount.decimal) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_primitives__WEBPACK_IMPORTED_MODULE_4__/* .Flex */ .kC, {
                            css: {
                                gap: "$2",
                                marginTop: "auto"
                            },
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .xv, {
                                    css: {
                                        color: "$gray11"
                                    },
                                    style: "subtitle3",
                                    children: "Last Sale"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_4__/* .FormatCryptoCurrency */ .gv, {
                                    logoHeight: 12,
                                    amount: (_token_token_lastSale_price_amount1 = token.token.lastSale.price.amount) === null || _token_token_lastSale_price_amount1 === void 0 ? void 0 : _token_token_lastSale_price_amount1.decimal,
                                    address: (_token_token_lastSale_price_currency = token.token.lastSale.price.currency) === null || _token_token_lastSale_price_currency === void 0 ? void 0 : _token_token_lastSale_price_currency.contract,
                                    decimals: (_token_token_lastSale_price_currency1 = token.token.lastSale.price.currency) === null || _token_token_lastSale_price_currency1 === void 0 ? void 0 : _token_token_lastSale_price_currency1.decimals,
                                    textStyle: "subtitle3",
                                    maximumFractionDigits: 4
                                })
                            ]
                        }) : null
                    ]
                })
            }),
            isOwner && (token === null || token === void 0 ? void 0 : (_token_market7 = token.market) === null || _token_market7 === void 0 ? void 0 : (_token_market_floorAsk7 = _token_market7.floorAsk) === null || _token_market_floorAsk7 === void 0 ? void 0 : (_token_market_floorAsk_price2 = _token_market_floorAsk7.price) === null || _token_market_floorAsk_price2 === void 0 ? void 0 : _token_market_floorAsk_price2.amount) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_primitives__WEBPACK_IMPORTED_MODULE_4__/* .Flex */ .kC, {
                className: "token-button-container",
                css: {
                    width: "100%",
                    transition: "bottom 0.25s ease-in-out",
                    position: "absolute",
                    bottom: -44,
                    left: 0,
                    right: 0,
                    gap: 1
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_buttons_BuyNow__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        tokenId: (_token_token14 = token.token) === null || _token_token14 === void 0 ? void 0 : _token_token14.tokenId,
                        collectionId: (_token_token15 = token.token) === null || _token_token15 === void 0 ? void 0 : (_token_token_collection = _token_token15.collection) === null || _token_token_collection === void 0 ? void 0 : _token_token_collection.id,
                        mutate: mutate,
                        buttonCss: {
                            justifyContent: "center",
                            flex: 1
                        },
                        buttonProps: {
                            corners: "square"
                        },
                        buttonChildren: "Buy Now"
                    }),
                    addToCartEnabled ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_buttons_AddToCart__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        token: token,
                        buttonCss: {
                            width: 52,
                            p: 0,
                            justifyContent: "center"
                        },
                        buttonProps: {
                            corners: "square"
                        }
                    }) : null
                ]
            }) : null
        ]
    });
});


/***/ }),

/***/ 87318:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ AttributeFilters; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var components_primitives__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21666);
/* harmony import */ var _AttributeSelector__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62347);
/* harmony import */ var _radix_ui_react_collapsible__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(48133);
/* harmony import */ var components_primitives_Collapsible__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61194);
/* harmony import */ var components_navbar__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48536);
/* harmony import */ var components_common_LoadingSpinner__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(74431);







const AttributeFilters = (param)=>{
    let { attributes , open , setOpen , scrollToTop  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_collapsible__WEBPACK_IMPORTED_MODULE_6__/* .Root */ .fC, {
        open: open,
        onOpenChange: setOpen,
        style: {
            transition: "width .5s",
            width: open ? 320 : 0
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives_Collapsible__WEBPACK_IMPORTED_MODULE_3__/* .CollapsibleContent */ .Fw, {
            css: {
                position: "sticky",
                top: 16 + 80,
                height: "calc(100vh - ".concat(components_navbar__WEBPACK_IMPORTED_MODULE_4__/* .NAVBAR_HEIGHT */ .ik, "px - 32px)"),
                overflow: "auto",
                marginBottom: 16,
                background: "transparent",
                border: "none",
                borderRadius: 0
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
                css: {
                    "& > div:first-of-type": {
                        pt: 0
                    }
                },
                children: [
                    attributes && attributes.filter((attribute)=>attribute.kind != "number").map((attribute)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_AttributeSelector__WEBPACK_IMPORTED_MODULE_2__/* .AttributeSelector */ .V, {
                            attribute: attribute,
                            scrollToTop: scrollToTop
                        }, attribute.key)),
                    (!attributes || !attributes.length) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
                        justify: "center",
                        align: "center",
                        css: {
                            height: 150
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common_LoadingSpinner__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            css: {
                                justifySelf: "center"
                            }
                        })
                    })
                ]
            })
        })
    });
};


/***/ }),

/***/ 62347:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ AttributeSelector; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(59417);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99603);
/* harmony import */ var components_primitives__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21666);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var utils_router__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(12700);







const AttributeSelector = (param)=>{
    let { attribute , scrollToTop  } = param;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    const [open, setOpen] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
        css: {
            pt: "$3",
            px: "$4",
            borderBottom: "1px solid $gray7",
            cursor: "pointer",
            "@md": {
                px: "0"
            }
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kC, {
                align: "center",
                justify: "between",
                css: {
                    mb: "$3",
                    cursor: "pointer"
                },
                onClick: ()=>setOpen(!open),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
                        as: "h5",
                        style: "subtitle1",
                        ellipsify: true,
                        children: attribute.key
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__/* .FontAwesomeIcon */ .G, {
                        icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_5__/* .faChevronDown */ .ptq,
                        style: {
                            transform: open ? "rotate(180deg)" : "rotate(0)",
                            transition: ".3s"
                        },
                        width: 16,
                        height: 16
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
                css: {
                    transition: "max-height .3s ease-in-out",
                    maxHeight: open ? 300 : 0,
                    overflow: "auto",
                    pb: open ? "$2" : ""
                },
                children: attribute.values && attribute.values.sort((a, b)=>{
                    if (!a.count || !b.count) {
                        return 0;
                    } else {
                        return b.count - a.count;
                    }
                }).map((value)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kC, {
                        css: {
                            mb: "$3",
                            gap: "$3"
                        },
                        align: "center",
                        onClick: ()=>{
                            if ((0,utils_router__WEBPACK_IMPORTED_MODULE_6__/* .hasParam */ .ke)(router, "attributes[".concat(attribute.key, "]"), value.value)) {
                                (0,utils_router__WEBPACK_IMPORTED_MODULE_6__/* .removeParam */ .$5)(router, "attributes[".concat(attribute.key, "]"), value.value);
                            } else {
                                (0,utils_router__WEBPACK_IMPORTED_MODULE_6__/* .addParam */ .b1)(router, "attributes[".concat(attribute.key, "]"), value.value);
                            }
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
                                style: "body1",
                                css: {
                                    color: "$gray11",
                                    flex: 1,
                                    whiteSpace: "pre",
                                    textOverflow: "ellipsis",
                                    overflow: "hidden"
                                },
                                children: value.value
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
                                style: "body3",
                                css: {
                                    color: "$gray11"
                                },
                                children: value.count
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kC, {
                                align: "center",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Switch */ .rs, {
                                    checked: (0,utils_router__WEBPACK_IMPORTED_MODULE_6__/* .hasParam */ .ke)(router, "attributes[".concat(attribute.key, "]"), value.value),
                                    onCheckedChange: (checked)=>{
                                        if (checked) {
                                            (0,utils_router__WEBPACK_IMPORTED_MODULE_6__/* .addParam */ .b1)(router, "attributes[".concat(attribute.key, "]"), value.value);
                                        } else {
                                            (0,utils_router__WEBPACK_IMPORTED_MODULE_6__/* .removeParam */ .$5)(router, "attributes[".concat(attribute.key, "]"), value.value);
                                        }
                                        scrollToTop();
                                    }
                                })
                            })
                        ]
                    }, value.value))
            })
        ]
    });
};


/***/ }),

/***/ 31085:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ MobileAttributeFilters; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(51528);
/* harmony import */ var components_primitives__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21666);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99603);
/* harmony import */ var _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(59417);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _AttributeSelector__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(62347);
/* harmony import */ var utils_router__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(12700);
/* harmony import */ var components_common_FullscreenModal__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(18491);
/* harmony import */ var components_navbar__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(48536);











const MobileAttributeFilters = (param)=>{
    let { attributes , scrollToTop  } = param;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    const [filtersLength, setFiltersLength] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        let filters = [];
        // Extract all queries of attribute type
        Object.keys({
            ...router.query
        }).map((key)=>{
            if (key.startsWith("attributes[") && key.endsWith("]") && router.query[key] !== "") {
                if (Array.isArray(router.query[key])) {
                    let values = router.query[key];
                    values.forEach((value)=>{
                        filters.push({
                            key: key.slice(11, -1),
                            value: value
                        });
                    });
                } else {
                    filters.push({
                        key: key.slice(11, -1),
                        value: router.query[key]
                    });
                }
            }
        });
        setFiltersLength(filters.length);
    }, [
        router.query
    ]);
    let filtersEnabled = filtersLength > 0;
    const trigger = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kC, {
        justify: "center",
        css: {
            position: "fixed",
            left: 0,
            bottom: "70px",
            width: "100vw",
            zIndex: 99
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .zx, {
            css: {
                justifyContent: "center",
                alignItems: "center",
                justifyItems: "center",
                position: "fixed",
                px: "$6",
                py: "$3",
                boxShadow: "0px 1px 5px rgba(0,0,0,0.2)"
            },
            type: "button",
            size: "small",
            corners: "pill",
            color: "gray3",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
                    style: "h6",
                    children: "Filter"
                }),
                filtersEnabled && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kC, {
                    justify: "center",
                    align: "center",
                    css: {
                        height: "24px",
                        width: "24px",
                        backgroundColor: "$gray4",
                        borderRadius: "100%",
                        fontSize: "medium",
                        fontWeight: "500"
                    },
                    children: filtersLength
                })
            ]
        })
    });
    if (attributes && (attributes === null || attributes === void 0 ? void 0 : attributes.length) === 0 || attributes === null || attributes === undefined) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_common_FullscreenModal__WEBPACK_IMPORTED_MODULE_6__/* .FullscreenModal */ .O, {
        trigger: trigger,
        children: [
            " ",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kC, {
                css: {
                    flexDirection: "column",
                    height: "100%",
                    width: "100%"
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kC, {
                        css: {
                            height: components_navbar__WEBPACK_IMPORTED_MODULE_7__/* .NAVBAR_HEIGHT_MOBILE */ .t7,
                            py: "$4",
                            px: "$4",
                            width: "100%",
                            borderBottom: "1px solid $gray4"
                        },
                        align: "center",
                        justify: "between",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kC, {
                                align: "center",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
                                        style: "h5",
                                        css: {
                                            mr: "$3"
                                        },
                                        children: "Filter"
                                    }),
                                    filtersEnabled && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kC, {
                                        justify: "center",
                                        css: {
                                            height: "24px",
                                            width: "24px",
                                            backgroundColor: "$gray3",
                                            borderRadius: "100%",
                                            mr: "$3"
                                        },
                                        children: filtersLength
                                    }),
                                    filtersEnabled && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .zx, {
                                        onClick: ()=>(0,utils_router__WEBPACK_IMPORTED_MODULE_8__/* .clearAllAttributes */ .Q1)(router),
                                        color: "ghost",
                                        size: "small",
                                        css: {
                                            color: "$primary11",
                                            fontWeight: 400
                                        },
                                        children: "Clear all"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_9__/* .Close */ .x8, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kC, {
                                    css: {
                                        justifyContent: "center",
                                        width: "44px",
                                        height: "44px",
                                        alignItems: "center",
                                        borderRadius: 8,
                                        backgroundColor: "$gray3",
                                        color: "$gray12",
                                        "&:hover": {
                                            backgroundColor: "$gray4"
                                        }
                                    },
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_3__/* .FontAwesomeIcon */ .G, {
                                        icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_10__/* .faXmark */ .g82,
                                        width: 16,
                                        height: 16
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kC, {
                        css: {
                            width: "100%",
                            maxHeight: "calc(100vh - ".concat(components_navbar__WEBPACK_IMPORTED_MODULE_7__/* .NAVBAR_HEIGHT_MOBILE */ .t7, "px)"),
                            overflowY: "auto"
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
                            css: {
                                width: "100%"
                            },
                            children: attributes && attributes.filter((attribute)=>attribute.kind != "number").map((attribute)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_AttributeSelector__WEBPACK_IMPORTED_MODULE_5__/* .AttributeSelector */ .V, {
                                    attribute: attribute,
                                    scrollToTop: scrollToTop
                                }, attribute.key))
                        })
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 16271:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var utils_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(12700);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var components_primitives__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21666);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99603);
/* harmony import */ var _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(59417);







const SelectedAttributes = ()=>{
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    const [filters, setFilters] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        let filters = [];
        // Extract all queries of attribute type
        // and convert into token format
        Object.keys({
            ...router.query
        }).map((key)=>{
            if (key.startsWith("attributes[") && key.endsWith("]") && router.query[key] !== "") {
                if (Array.isArray(router.query[key])) {
                    let values = router.query[key];
                    values.forEach((value)=>{
                        filters.push({
                            key: key.slice(11, -1),
                            value: value
                        });
                    });
                } else {
                    filters.push({
                        key: key.slice(11, -1),
                        value: router.query[key]
                    });
                }
            }
        });
        setFilters(filters);
    }, [
        router.query
    ]);
    if (filters.length === 0) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_primitives__WEBPACK_IMPORTED_MODULE_3__/* .Flex */ .kC, {
        wrap: "wrap",
        align: "center",
        children: [
            filters.map((param)=>/*#__PURE__*/ {
                let { key , value  } = param;
                return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_primitives__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .zx, {
                    onClick: ()=>{
                        (0,utils_router__WEBPACK_IMPORTED_MODULE_5__/* .removeParam */ .$5)(router, "attributes[".concat(key, "]"), value);
                    },
                    color: "gray4",
                    css: {
                        mr: "$4",
                        mb: "24px"
                    },
                    size: "small",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_primitives__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .xv, {
                            css: {
                                color: "$primary11"
                            },
                            children: [
                                key,
                                ":"
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .xv, {
                            style: "subtitle1",
                            children: value
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .xv, {
                            css: {
                                color: "$gray9"
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_4__/* .FontAwesomeIcon */ .G, {
                                icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_6__/* .faClose */ .YIN,
                                width: "16",
                                height: "16"
                            })
                        })
                    ]
                }, key + value);
            }),
            filters.length > 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .zx, {
                onClick: ()=>{
                    (0,utils_router__WEBPACK_IMPORTED_MODULE_5__/* .clearAllAttributes */ .Q1)(router);
                },
                color: "ghost",
                css: {
                    color: "$primary11",
                    fontWeight: 500,
                    mb: "24px"
                },
                children: "Clear all"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SelectedAttributes);


/***/ }),

/***/ 39944:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _stitches_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86744);
/* harmony import */ var components_primitives__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21666);



const pulse = (0,_stitches_react__WEBPACK_IMPORTED_MODULE_2__/* .keyframes */ .F4)({
    "0%": {
        backgroundColor: "$gray6"
    },
    "50%": {
        backgroundColor: "$gray8"
    },
    "100%": {
        backgroundColor: "$gray6"
    }
});
const LoadingCard = ()=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
        direction: "column",
        justify: "end",
        css: {
            borderRadius: 8,
            overflow: "hidden",
            background: "$gray6",
            height: "100%",
            minHeight: 332,
            "@md": {
                minHeight: 372
            }
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
            css: {
                background: "$gray4",
                p: "$4",
                height: 132
            },
            direction: "column",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
                    css: {
                        mb: "$4",
                        height: "100%"
                    },
                    align: "center",
                    justify: "between",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
                            css: {
                                height: 20,
                                width: 120,
                                background: "$gray6",
                                animation: "".concat(pulse, " 2s ease-in infinite")
                            }
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
                            css: {
                                height: 20,
                                width: 40,
                                background: "$gray6",
                                animation: "".concat(pulse, " 2s ease-in infinite")
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
                    css: {
                        mb: "$4",
                        height: "100%"
                    },
                    align: "center",
                    justify: "between",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
                            css: {
                                height: 20,
                                width: 60,
                                background: "$gray6",
                                animation: "".concat(pulse, " 2s ease-in infinite")
                            }
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
                            css: {
                                height: 20,
                                width: 20,
                                background: "$gray6",
                                animation: "".concat(pulse, " 2s ease-in infinite")
                            }
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LoadingCard);


/***/ }),

/***/ 12700:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$5": function() { return /* binding */ removeParam; },
/* harmony export */   "Q1": function() { return /* binding */ clearAllAttributes; },
/* harmony export */   "b1": function() { return /* binding */ addParam; },
/* harmony export */   "ke": function() { return /* binding */ hasParam; }
/* harmony export */ });
/**
   * Adds a param to the URL string. Multiple params with the same name
   * and different values can be added.
   * @param router Next router
   * @param name The name of the param.
   * @param value The value of the param.
   */ const addParam = (router, name, value)=>{
    const { [name]: param , ...rest } = router.query;
    let newQuery;
    if (!param) {
        newQuery = {
            ...rest,
            [name]: value
        };
    } else if (Array.isArray(param)) {
        if (param.indexOf(encodeURIComponent(value)) > -1) return;
        newQuery = {
            ...rest,
            [name]: [
                ...param,
                value
            ]
        };
    } else {
        if (param === encodeURIComponent(value)) return;
        newQuery = {
            ...rest,
            [name]: [
                param,
                value
            ]
        };
    }
    router.push({
        query: newQuery
    }, undefined, {
        shallow: true
    });
};
/**
   * Removes the provided params with a specific value from the URL.
   * @param router Next router
   * @param name The name of the param.
   * @param value The value of the param.
   */ const removeParam = (router, name, value)=>{
    const { [name]: param , ...rest } = router.query;
    if (!param) {
        return;
    }
    let newQuery;
    if (value && Array.isArray(param) && !Array.isArray(value)) {
        newQuery = {
            ...rest,
            [name]: param.filter((element)=>element !== value)
        };
    } else {
        newQuery = {
            ...rest
        };
    }
    router.push({
        query: newQuery
    }, undefined, {
        shallow: true
    });
};
/**
   * Checks whether a param is exposed in the URL string or not.
   * @param router Next router
   * @param name The name of the param.
   * @param value Optional, the param must have the specified value.
   * @returns true/false depending on the presence of the param.
   */ const hasParam = (router, name, value)=>{
    const { [name]: param  } = router.query;
    if (!value) {
        return !!param;
    }
    if (!param) {
        return false;
    } else if (Array.isArray(param)) {
        return param.indexOf(value.toString()) > -1;
    } else {
        return param === value;
    }
};
/**
   * Deletes all 'attribute' params from the URL string
  */ function clearAllAttributes(router) {
    Object.keys(router.query).find((key)=>{
        if (key.startsWith("attributes[") && key.endsWith("]") && router.query[key] !== "") {
            delete router.query[key];
        }
    });
    router.push({
        query: {
            ...router.query
        }
    }, undefined, {
        shallow: true
    });
}



/***/ })

}]);